import { FeedingReportsService } from "../../routes/services/feeding-reports.service";
import { ClientsService } from "../../routes/services/clients.service";
import { StorageService } from "../../routes/services/storage.service";
import { FramesService } from "../../routes/services/frames.service";
import { GlobalFunction } from "../../routes/services/globalFuntion";
import { PondService } from "../../routes/services/pond.service";
import { Uris } from "../../routes/services/Uris";
import { FormBuilder } from "@angular/forms";
import moment from "moment";
import { FarmService } from "../../routes/services/farm.service";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { graph_sensor } from "./constants";
import { Router } from "@angular/router";

@Component({
  selector: "app-view-fuzzy-logic",
  templateUrl: "./view_fuzzy_logic.html",
  styleUrls: ["./view_fuzzy_logic.scss"]
})
export class ViewFuzzyLogicComponent implements OnInit {
  view: "tray" | "equation" | "sensors" = "sensors";
  @Input() pond_id: null | number = null;

  @Output() click_recomendation = new EventEmitter();
  @ViewChild("sensor_config") public sensor_config_modal;
  @ViewChild("graph_sensor") public graphSensor;
  @ViewChild("feeding_reports_fuzzy_logic") public feedingReportsFuzzyLogic;

  @Input() reload: boolean = false;

  tray_data = {
    tray_record: "",
    percent: "",
    recommended: ""
  };

  diffuse_logic = {
    recommendation: null,
    weight: null
  };

  feedingReport: FeedingReport | null = null;

  configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
    centered: true,
    size: "lg",
    class: "modal-config"
  };
  grap_option: any = graph_sensor;

  loading_graph = false;
  loading_reports = false;

  timeGroup: any;

  loading_feeding = {
    url: "",
    view: true
  };
  time_loadings = 300;

  totalDifference: number = 0;
  totalDifferencePercent: number = 0;
  KgsFeeders: number = 0;

  constructor(
    public feedingReportsService: FeedingReportsService,
    public globalFunction: GlobalFunction,
    public clientService: ClientsService,
    public storageService: StorageService,
    public frameService: FramesService,
    public pondService: PondService,
    public fb: FormBuilder,
    public farmService: FarmService,
    public route: Router
  ) {
    this.timeGroup = this.fb.group({
      dateOption: "today",
      date: moment().format("YYYY-MM-DD")
    });
  }
  ngOnInit(): void {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pond_id"] && changes["pond_id"].currentValue) {
      this.getData(changes["pond_id"].currentValue);
    }
    if (changes["reload"]) {
      if (this.pond_id) {
        this.getData(this.pond_id);
      }
    }
  }

  getData = (id: number) => {
    // Detalle de un estanque: `ordering` no aplica y solo calculaba anotaciones caras
    const object_query_pond = {
      fields: ["diffuse_logic"],
      all_records: true
    };
    const query_pond = this.globalFunction.constructQuery(object_query_pond);

    if (id) {
      const object_query_feeding = {
        pond_id: id,
        page: 1,
        page_size: 1,
        ordering: "-date,number",
        fields: ["kgs_fed", "fuzzy_logic_update"],
        type: 0,
        projection: false
      };
      const query_feeding = this.globalFunction.constructQuery(object_query_feeding);

      const url_feeding = Uris.FEEDINGREPORTS + query_feeding;
      this.loading_feeding = { url: url_feeding, view: true };

      this.getFuzyLogic(id, query_pond, query_feeding).then((resp: any) => {
        this.diffuse_logic = resp.diffuse_logic.diffuse_logic;
        this.feedingReport = resp.feeding_report.results[0];
        this.tray_data = resp.try_data;
        console.log("RESPUESTA GENERAL", resp);
        setTimeout(() => {
          this.loading_feeding = { url: url_feeding, view: false };
        }, this.time_loadings);
      });
    }
  };

  getFuzyLogic(pond_id: number, query_pond: string, query_feeding: string) {
    return new Promise(async (resolve, reject) => {
      try {
        const diffuse_logic = await this.pondService.getPonds(query_pond, pond_id).toPromise();
        const feeding_report = await this.feedingReportsService
          .getFeedingReports(query_feeding)
          .toPromise();
        const try_data = await this.pondService.trayData(pond_id).toPromise();

        resolve({
          diffuse_logic,
          feeding_report,
          try_data
        });
      } catch (error) {
        reject(error);
      }
    });
  }

  recomendation(value: number) {
    this.click_recomendation.emit({
      section: this.view,
      value
    });
  }

  Modal = (template: TemplateRef<any>, type: "show" | "hide", config = this.configModal) => {
    this.globalFunction.Modal(template, type, config);
  };

  getAllDataGraph = () => {
    return new Promise(async (resolve, reject) => {
      const date = `?date=${this.timeGroup.value.date}`;
      const datetime_range = `?datetime_range=${this.timeGroup.value.date}`;
      try {
        const fuzzyLogic = await this.pondService
          .getFeedingFuzzyLogicGraph(datetime_range + `&pond_id=${this.pond_id}`)
          .toPromise();
        const Feeding = await this.pondService
          .getFeedingBehaviorGraph(this.pond_id, date)
          .toPromise();
        const query = `?pond_id=${this.pond_id}&page=1&page_size=1&ordering=-date,number&type=0&projection=false`;

        const feed = await this.feedingReportsService.getFeedingReports(query).toPromise();

        if (fuzzyLogic && Feeding && feed) {
          resolve({
            responseFeedingBehaviorGraph: Feeding,
            responseFuzzyLogic: fuzzyLogic,
            diet: feed && feed.results.length > 0 ? feed.results[0].diet : null
          });
        }
      } catch (error) {
        reject(error);
      }
    });
  };

  viewChart(show_modal = true) {
    this.loading_graph = true;

    const responseFeedingBehaviorGraph: FeedData[] = [
      {
        hour: 0,
        kgs_target: 9,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -9,
        percent: -1,
        datetime: "2025-08-12T00:00:00-07:00"
      },
      {
        hour: 1,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T01:00:00-07:00"
      },
      {
        hour: 2,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T02:00:00-07:00"
      },
      {
        hour: 3,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T03:00:00-07:00"
      },
      {
        hour: 4,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T04:00:00-07:00"
      },
      {
        hour: 5,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T05:00:00-07:00"
      },
      {
        hour: 6,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T06:00:00-07:00"
      },
      {
        hour: 7,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T07:00:00-07:00"
      },
      {
        hour: 8,
        kgs_target: 0,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T08:00:00-07:00"
      },
      {
        hour: 9,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T09:00:00-07:00"
      },
      {
        hour: 10,
        kgs_target: 36,
        kgs_feed: 0,
        title: "Fallo de alimentación",
        reason: "La alimentadora tiene un problema de estado",
        kgs_dist: -36,
        percent: -1,
        datetime: "2025-08-12T10:00:00-07:00"
      },
      {
        hour: 11,
        kgs_target: 45,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -45,
        percent: -1,
        datetime: "2025-08-12T11:00:00-07:00"
      },
      {
        hour: 12,
        kgs_target: 36,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -36,
        percent: -1,
        datetime: "2025-08-12T12:00:00-07:00"
      },
      {
        hour: 13,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T13:00:00-07:00"
      },
      {
        hour: 14,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T14:00:00-07:00"
      },
      {
        hour: 15,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T15:00:00-07:00"
      },
      {
        hour: 16,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T16:00:00-07:00"
      },
      {
        hour: 17,
        kgs_target: 18,
        kgs_feed: 0,
        title: "",
        reason: "",
        kgs_dist: -18,
        percent: -1,
        datetime: "2025-08-12T17:00:00-07:00"
      },
      {
        hour: 18,
        kgs_target: 27,
        kgs_feed: 0,
        title: "Fallo de alimentación",
        reason: "La alimentadora tiene un problema de estado",
        kgs_dist: -27,
        percent: -1,
        datetime: "2025-08-12T18:00:00-07:00"
      },
      {
        hour: 19,
        kgs_target: 45,
        kgs_feed: 45,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T19:00:00-07:00"
      },
      {
        hour: 20,
        kgs_target: 45,
        kgs_feed: 45,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T20:00:00-07:00"
      },
      {
        hour: 21,
        kgs_target: 45,
        kgs_feed: 45,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T21:00:00-07:00"
      },
      {
        hour: 22,
        kgs_target: 45,
        kgs_feed: 45,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T22:00:00-07:00"
      },
      {
        hour: 23,
        kgs_target: 9,
        kgs_feed: 9,
        title: "",
        reason: "",
        kgs_dist: 0,
        percent: 0,
        datetime: "2025-08-12T23:00:00-07:00"
      }
    ];

    const responseFuzzyLogic: FuzzyData[] = [
      {
        created_at: "2025-08-12T10:00:00-07:00",
        target_datetime: "2025-08-12T11:00:00-07:00",
        modifier: 110,
        kgs_original_feed: 450,
        kgs_new_feed: 495.00000000000006,
        kgs_diff: 45.00000000000006,
        kgs_hour: 49.50000000000001,
        hour: 18,
        feeder_count: 4,
        water_temp: 30.93,
        oxygen_level: 6.68
      },
      {
        created_at: "2025-08-12T13:00:00-07:00",
        target_datetime: "2025-08-12T14:00:00-07:00",
        modifier: 119.99480154548667,
        kgs_original_feed: 450,
        kgs_new_feed: 539.97660695469,
        kgs_diff: 89.97660695469006,
        kgs_hour: 21.5990642781876,
        hour: 21,
        feeder_count: 4,
        water_temp: 33.93,
        oxygen_level: 9.05
      },
      {
        created_at: "2025-08-12T16:00:00-07:00",
        target_datetime: "2025-08-12T17:00:00-07:00",
        modifier: 119.99480154548667,
        kgs_original_feed: 450,
        kgs_new_feed: 539.97660695469,
        kgs_diff: 89.97660695469006,
        kgs_hour: 21.5990642781876,
        hour: 0,
        feeder_count: 2,
        water_temp: 33.5,
        oxygen_level: 9.08
      },
      {
        created_at: "2025-08-12T17:00:00-07:00",
        target_datetime: "2025-08-12T18:00:00-07:00",
        modifier: 119.99480154548667,
        kgs_original_feed: 450,
        kgs_new_feed: 539.97660695469,
        kgs_diff: 89.97660695469006,
        kgs_hour: 32.398596417281404,
        hour: 1,
        feeder_count: 0,
        water_temp: 33.68,
        oxygen_level: 8.78
      },
      {
        created_at: "2025-08-12T18:00:00-07:00",
        target_datetime: "2025-08-12T19:00:00-07:00",
        modifier: 119.99480154548667,
        kgs_original_feed: 450,
        kgs_new_feed: 539.97660695469,
        kgs_diff: 89.97660695469006,
        kgs_hour: 53.99766069546901,
        hour: 2,
        feeder_count: 0,
        water_temp: 33.68,
        oxygen_level: 8.78
      },
      {
        created_at: "2025-08-12T18:00:00-07:00",
        target_datetime: "2025-08-12T19:00:00-07:00",
        modifier: 119.99788677089737,
        kgs_original_feed: 450,
        kgs_new_feed: 539.9904904690381,
        kgs_diff: 89.99049046903815,
        kgs_hour: 53.99904904690382,
        hour: 2,
        feeder_count: 0,
        water_temp: 33.12,
        oxygen_level: 7.73
      },
      {
        created_at: "2025-08-12T19:00:00-07:00",
        target_datetime: "2025-08-12T20:00:00-07:00",
        modifier: 119.99788677089737,
        kgs_original_feed: 450,
        kgs_new_feed: 539.9904904690381,
        kgs_diff: 89.99049046903815,
        kgs_hour: 53.99904904690382,
        hour: 3,
        feeder_count: 0,
        water_temp: 33.12,
        oxygen_level: 7.73
      },
      {
        created_at: "2025-08-12T19:00:00-07:00",
        target_datetime: "2025-08-12T20:00:00-07:00",
        modifier: 110.81192936745798,
        kgs_original_feed: 450,
        kgs_new_feed: 498.6536821535609,
        kgs_diff: 48.65368215356091,
        kgs_hour: 49.86536821535609,
        hour: 3,
        feeder_count: 0,
        water_temp: 32.31,
        oxygen_level: 5.89
      },
      {
        created_at: "2025-08-12T20:00:00-07:00",
        target_datetime: "2025-08-12T21:00:00-07:00",
        modifier: 110.81192936745798,
        kgs_original_feed: 450,
        kgs_new_feed: 498.6536821535609,
        kgs_diff: 48.65368215356091,
        kgs_hour: 49.86536821535609,
        hour: 4,
        feeder_count: 0,
        water_temp: 32.31,
        oxygen_level: 5.89
      },
      {
        created_at: "2025-08-12T20:00:00-07:00",
        target_datetime: "2025-08-12T21:00:00-07:00",
        modifier: 110.00000000000006,
        kgs_original_feed: 450,
        kgs_new_feed: 495.0000000000002,
        kgs_diff: 45.00000000000023,
        kgs_hour: 49.50000000000003,
        hour: 4,
        feeder_count: 0,
        water_temp: 32,
        oxygen_level: 4.61
      },
      {
        created_at: "2025-08-12T21:00:00-07:00",
        target_datetime: "2025-08-12T22:00:00-07:00",
        modifier: 110.00000000000006,
        kgs_original_feed: 450,
        kgs_new_feed: 495.0000000000002,
        kgs_diff: 45.00000000000023,
        kgs_hour: 49.50000000000003,
        hour: 5,
        feeder_count: 0,
        water_temp: 32,
        oxygen_level: 4.61
      },
      {
        created_at: "2025-08-12T21:00:00-07:00",
        target_datetime: "2025-08-12T22:00:00-07:00",
        modifier: 109.99999999999984,
        kgs_original_feed: 450,
        kgs_new_feed: 494.9999999999993,
        kgs_diff: 44.99999999999932,
        kgs_hour: 49.499999999999936,
        hour: 5,
        feeder_count: 0,
        water_temp: 31.68,
        oxygen_level: 4.11
      },
      {
        created_at: "2025-08-12T22:00:00-07:00",
        target_datetime: "2025-08-12T23:00:00-07:00",
        modifier: 109.99999999999984,
        kgs_original_feed: 450,
        kgs_new_feed: 494.9999999999993,
        kgs_diff: 44.99999999999932,
        kgs_hour: 9.899999999999986,
        hour: 6,
        feeder_count: 0,
        water_temp: 31.68,
        oxygen_level: 4.11
      },
      {
        created_at: "2025-08-12T22:00:00-07:00",
        target_datetime: "2025-08-12T23:00:00-07:00",
        modifier: 109.99999999999972,
        kgs_original_feed: 450,
        kgs_new_feed: 494.99999999999875,
        kgs_diff: 44.99999999999875,
        kgs_hour: 9.899999999999975,
        hour: 6,
        feeder_count: 0,
        water_temp: 31.18,
        oxygen_level: 4
      },
      {
        created_at: "2025-08-12T23:00:00-07:00",
        target_datetime: "2025-08-13T00:00:00-07:00",
        modifier: 109.99999999999972,
        kgs_original_feed: 450,
        kgs_new_feed: 494.99999999999875,
        kgs_diff: 44.99999999999875,
        kgs_hour: 9.899999999999975,
        hour: 7,
        feeder_count: 0,
        water_temp: 31.18,
        oxygen_level: 4
      }
    ];

    this.getAllDataGraph().then((item: any) => {
      this.loading_graph = false;
      const merged: Graph[] = item.responseFeedingBehaviorGraph.map((feed: any) => {
        const fuzzy = item.responseFuzzyLogic.find((f: any) => f.hour === feed.hour) || null;

        return {
          ...feed,
          fuzzy_data: fuzzy,
          diet: item.diet
        };
      });

      let totalkgsMod = 0;
      let totalkgs = 0;
      let totalDifference = 0;

      merged.forEach((item, index) => {
        const percentage = Number(item.diet?.percentages[index]) * 100;
        const kgsNum = percentage * Number(item.kgs_feed);
        const kgsMod = kgsNum * Number(item.fuzzy_data?.modifier);
        const difference = kgsMod - kgsNum;
        totalkgsMod += kgsMod;
        totalkgs += kgsNum;
        totalDifference += difference;
      });
      const count_feeder = merged.find((item) => item.fuzzy_data)?.fuzzy_data?.feeder_count;

      this.totalDifference = Number(totalkgsMod);

      if (this.totalDifference > 0) {
        const value = 100 - (this.totalDifference / totalkgs) * 100;
        this.totalDifferencePercent = value;
      }
      if (count_feeder === 0) {
        this.KgsFeeders = 0;
      } else {
        this.KgsFeeders = this.totalDifference / Number(count_feeder);
      }
      this.grap_option = this.construct_graph(merged);

      show_modal &&
        this.Modal(this.graphSensor, "show", {
          backdrop: true,
          ignoreBackdropClick: true,
          keyboard: false,
          centered: true,
          size: "xl",
          class: "modal-config"
        });
    });
  }
  construct_graph = (data_graph: Graph[]) => {
    const validate_limit = (hour: number) => {
      const lower = hour - 1;
      const higher = hour + 1;
      if (lower < 1 || higher > 24) {
        return {
          lower: hour,
          higher: hour
        };
      }
      return {
        lower,
        higher
      };
    };
    const hours = data_graph.map((item) => item.hour + 1);
    const target_value = data_graph.map((item) => (item.fuzzy_data ? item.fuzzy_data.kgs_hour : 0));

    const diet_value = data_graph.map((item) => item.kgs_target);

    const detect_alert = data_graph
      .filter((item) => item.title)
      .map((item) => {
        /* kgs_feed !== kgs_target mostrar una alerta */
        const hour = new Date(item.datetime);

        const lower_limit = validate_limit(hour.getHours()).lower;
        const higher_limit = hour.getHours();

        return [
          {
            name: item.title,
            xAxis: lower_limit ? lower_limit : hour.getHours()
          },
          {
            xAxis: higher_limit
          }
        ];
      });

    const format = (val: number | "") =>
      val.toLocaleString("es-MX", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    const tooltips = (params: any) => {
      const index = Number(params[0].dataIndex);
      const item = data_graph[index];
      const diet = item.diet;
      const fuzzyLogic = item.fuzzy_data;

      const validate_alert = () => {
        if (item) {
          if (item.title) {
            return `<b>${item.title}</b> <hr class="m-1">
            ${item.reason} <br>`;
          }
        }
        return "";
      };
      /* PORCENTAJE DE LA DIETA */

      const default_percentage = diet ? Number(diet.percentages[index]) * 100 : 0;

      const modifierNum = fuzzyLogic && fuzzyLogic.modifier ? Number(fuzzyLogic.modifier) : 0;
      const feedersNum =
        fuzzyLogic && fuzzyLogic.feeder_count ? Number(fuzzyLogic.feeder_count) : 1;
      /* kgs totales NORMAL */
      const kgsNum = default_percentage * Number(item.kgs_feed);
      /* kgs totales INTELIGENTE */
      const kgsMod = kgsNum * modifierNum;
      /* kgs por alimentador NORMAL*/
      const kgsPerFeeder = kgsNum / feedersNum;
      /* kgs por alimentador INTELIGENTE */
      const kgsModPerFeeder = kgsMod / feedersNum;

      return `
     <div class="text-center"> ${validate_alert()}</div>
    <div
  style="display:flex; flex-direction:column; gap:20px; font-family: 'Segoe UI', sans-serif; font-size: 18px; padding: 20px;">
  <!-- Hora y Porcentaje -->
  <div
    style="position:relative; border: 1px solid rgba(0, 0, 0, 0.1); padding: 25px; border-radius: 10px; background-color: #fff;">
    <div style="display: flex; justify-content: space-between;">
          <div>Hora: ${item.hour + 1}</div>
          <div>Porcentaje: ${format(default_percentage)}%</div>
    </div>

    <div
      style="position:absolute; background-color: white; bottom:-17px; left:15px; border-radius:10px; padding: 4px 10px;">
      <strong>Dieta</strong>
    </div>
  </div>

  <!-- Oxígeno, Temperatura, Modificador -->
  <div
    style="position:relative; border: 1px solid rgba(0, 0, 0, 0.1); padding: 25px; border-radius: 10px; background-color: #fff;">
    <div style="display: flex; justify-content: space-between;">
      <div>
        <div>Oxígeno: ${fuzzyLogic ? format(fuzzyLogic.oxygen_level) : ""}</div>
        <div style="margin-top:5px">Temperatura: ${format(
          fuzzyLogic ? fuzzyLogic.water_temp : ""
        )} °C</div>
      </div>
      <div
        style="display:flex; align-items: center; justify-content: center; flex-direction:column; text-align: right;">
        <div style="font-weight: 800; font-size: 30px;">${format(modifierNum)}%</div>
        <div style="font-size: 12px; font-weight: 400; color: #555;">Modificador</div>
      </div>
    </div>
    <div
      style="position:absolute; background-color: white; bottom:-17px; left:15px; border-radius:10px; padding: 4px 10px;">
      <strong>AI</strong>
    </div>
  </div>

  <!-- Comparativa de Alimentación -->
  <div
    style="position: relative; border: 1px solid rgba(0, 0, 0, 0.1); padding: 12px 12px 25px; border-radius: 10px; background-color: #fff;">
    <table style="width: 100%; border-collapse: collapse; font-family: 'Segoe UI', sans-serif; font-size: 16px;">
      <thead>
        <tr>
          <th style="padding: 8px; text-align: left; font-size:18px; font-weight:500;"></th>
          <th
            style="padding: 8px; color: #91cc75; text-align: center; font-size:18px; font-weight:500; border-bottom: 1px solid #f3eded;">
            Normal</th>
          <th
            style="padding: 8px; color: #5470c6; text-align: center; font-size:18px; font-weight:500; border-bottom: 1px solid #f3eded;">
            Inteligente</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="padding: 6px 20px 6px 6px; text-align: left; font-size:16px;">Total</td>
          <td style="padding: 6px 8px; text-align: center; font-size: 18px;">${format(
            kgsNum
          )}kg </td>
          <td style="padding: 6px 8px; text-align: center; font-size: 18px; border-left: 1px solid #f3eded;">${format(
            kgsMod
          )}kg
          </td>
        </tr>
        <tr>
          <td style="padding: 6px 20px 6px 6px; text-align: left; font-size:16px;">* Alimentador</td>
          <td style="padding: 6px 8px; text-align: center; font-size: 18px;">${format(
            kgsPerFeeder
          )}kg </td>
          <td style="padding: 6px 8px; text-align: center; font-size: 18px; border-left: 1px solid #f3eded;">${format(
            kgsModPerFeeder
          )}kg
          </td>
        </tr>
      </tbody>
    </table>
    <div
      style="position:absolute; background-color: white; bottom:-17px; left:15px; border-radius:10px; padding: 4px 10px;">
      <strong>Alimentación</strong>
    </div>
  </div>
</div>
  `;

      /*  return `
          Dieta: <b> ${value(item.kgs_target)}Kg.</b> <br>
          Ajustados:  <b>${value(fuzzyLogic.kgs_hour)}Kg.</b> <br>
          Temperatura de estanque:  <b>${value(
            fuzzyLogic.water_temp
          )}°C</b> <br>
          Oxigeno:  <b>${value(fuzzyLogic.oxygen_level)}mg/L </b> <br>
          Modificador:  <b>${value(fuzzyLogic.modifier)}%</b> <br>
          Alimentadores:  <b>${fuzzyLogic.feeder_count}</b> <br>
        `; */
    };
    let active = true;

    const pieces = data_graph.map((item) => {
      const hour = item.hour;

      let iscurrent = !item.title;
      active = iscurrent;
      if (active) {
        return {
          lte: hour,
          color: "#30646c"
        };
      } else {
        return {
          lte: hour,
          color: "red"
        };
      }
    });
    let series: any = this.grap_option.series;
    series[0] = {
      ...series[0],
      markArea: {
        ...series[0].markArea,
        data: detect_alert
      }
    };

    series[1] = {
      ...series[1],
      data: diet_value
    };
    series[2] = {
      ...series[2],
      data: target_value
    };

    return {
      ...this.grap_option,
      tooltip: {
        ...this.grap_option.tooltip,
        formatter: tooltips
      },
      visualMap: {
        ...this.grap_option.visualMap,
        pieces: pieces,
        seriesIndex: 1
      },
      xAxis: {
        ...this.grap_option.xAxis,
        data: hours.map((item) => item)
      },
      series: series
    };
  };

  lastFeedingReport: any = null;
  tablefeedingReports: any = [];
  timezone = "";
  viewFeedingReportsFuzzyLogic = async () => {
    const farm_id = this.storageService.localValue.farm_id;
    const farm = await this.farmService.getFarm(farm_id, "?fields=id,timezone").toPromise();
    if (farm) {
      this.timezone = farm.timezone;
      this.getTableFeedingReports(true);
    }
  };
  queryGenerated = "";
  pagination = 1;
  count = 0;
  pageSize = 10;
  handleQueryGenerated(query: string) {
    this.queryGenerated = query;
    this.getTableFeedingReports();
  }

  getTableFeedingReports = async (view_modal = false) => {
    const id = this.pond_id;

    let now = moment();
    const end_date = now.format("YYYY-MM-DD");

    const date = this.timeGroup.controls["date"].value;
    const query_pagination = `?page=${this.pagination}&page_size=${this.pageSize}&created_at=${date},${end_date}`;
    const query = query_pagination + `&ordering=-id`;

    this.feedingReportsService.getFeedingFuzzyLogic(id, query).subscribe(
      (resp) => {
        if (resp) {
          this.tablefeedingReports = resp.results.map((item) => {
            const created_at = this.globalFunction.insertTimeZone(item.created_at, this.timezone);
            if (created_at) {
              const hour = moment(created_at).hour();
              return {
                ...item,
                created_at,
                hour
              };
            }
            return item;
          });
          this.count = resp.count;
          this.loading_reports = false;
        }

        if (view_modal) {
          this.Modal(this.feedingReportsFuzzyLogic, "show", {
            backdrop: true,
            ignoreBackdropClick: true,
            keyboard: false,
            centered: true,
            size: "xl",
            class: "modal-config"
          });
        }
      },
      (err) => {
        this.loading_reports = false;
      }
    );
  };
  getlistpagination(page: number) {
    this.pagination = page;
    this.getTableFeedingReports();
  }

  setValueYesterday = (feeding_report = false) => {
    let yesterday = moment().subtract(24, "hours");
    let firstDate = yesterday.format("YYYY-MM-DD");
    this.timeGroup.controls["date"].setValue(firstDate);
    if (!feeding_report) {
      this.viewChart(false);
    } else {
      this.getTableFeedingReports();
    }
  };
  setValueToday = (feeding_report = false) => {
    let today = moment().format("YYYY-MM-DD");
    this.timeGroup.controls["date"].setValue(today);
    if (!feeding_report) {
      this.viewChart(false);
    } else {
      this.getTableFeedingReports();
    }
  };
  calculateModifier = (item, withModifier) => {
    if (!item) return "";

    const { kgs = 0, modifier = 1, percentage = 1 } = item;

    const base = Number(kgs) * Number(percentage);
    return withModifier ? (base * Number(modifier)).toFixed(2) : base.toFixed(2);
  };
  sendKg(feedingReport: FeedingReport | null): string {
    if (!feedingReport?.fuzzy_logic_update?.modifier || !feedingReport?.kgs_fed) {
      return "n/a";
    }

    const kgs_fed = Number(feedingReport.kgs_fed);
    const fuzzyModifier = Number(feedingReport.fuzzy_logic_update.modifier);

    if (isNaN(kgs_fed) || isNaN(fuzzyModifier)) {
      return "n/a";
    }

    return ((kgs_fed * fuzzyModifier) / 100).toFixed(2);
  }
  navigateFuzzyLogic() {
    this.route.navigateByUrl(`/proyecion-de-alimentacion/${this.pond_id}`);
  }
}
interface Graph extends FeedData {
  fuzzy_data: FuzzyData | null;
  diet: Diet | null;
}
export interface Diet {
  id: number;
  timezone: string;
  hours: number[];
  name: string;
  percentages: number[];
  intervals: number[];
  created_date: string;
  beginning: number;
  farms: number[];
}

interface FeedData {
  hour: number;
  kgs_target: number;
  kgs_feed: number;
  title: string;
  reason: string;
  kgs_dist: number;
  percent: number;
  datetime: string;
}

interface FuzzyData {
  created_at: string;
  target_datetime: string;
  modifier: number;
  kgs_original_feed: number;
  kgs_new_feed: number;
  kgs_diff: number;
  kgs_hour: number;
  hour: number;
  feeder_count: number;
  water_temp: number;
  oxygen_level: number;
}

interface FeedingReportFuzzyLogicUpdate {
  modifier: number | null;
  water_temp: number | null;
  oxygen_level: number | null;
  created_at: string | null;
}

interface FeedingReport {
  kgs_fed: number | string | null;
  fuzzy_logic_update: FeedingReportFuzzyLogicUpdate | null;
}
